import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>GAINING CONTROL
                                            </div>
                                            <p>The following section is about how to use motivation as a
                                                positive force at work. Motivation will
                                                help you to take control of a situation. This includes
                                                motivating yourself (direct personal control)
                                                and others (socially mediated proxy control).</p>
                                            <div className="border_subtitle">Goal setting<a
                                                className="superscripttext boldlink"
                                                href="further_info.php?course=300"><sup>5</sup></a></div>
                                            <div className="uiheading"><p>Increase both your, and your team’s,
                                                motivation by setting specific or challenging goals.
                                                Encouraging your team’s input in the goal-setting process will
                                                increase their sense of involvement
                                                and shared control, because achieving goals grows self-esteem
                                                and the incentive to take on
                                                more. Give them feedback about their performance, or if you are
                                                goal setting for yourself, evaluate
                                                your own performance. So, when setting goals:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>Make them clear and specific</li>
                                                <li>Make them challenging and achievable</li>
                                                <li>If you are setting goals for others, involve them in the
                                                    process
                                                </li>
                                                <li>Provide feedback on performance or self-evaluate your own
                                                    performance.
                                                </li>
                                            </ul>

                                            <div className="border_subtitle">What’s in it for me?<a
                                                className="superscripttext boldlink"
                                                href="further_info.php?course=300"><sup>6</sup></a></div>
                                            <div className="uiheading"><p>Most people are motivated to do
                                                something if there’s something in it for them! For your team or
                                                yourself consider:</p></div>
                                            <ul className="greenbullet-list">
                                                <li>Do you and your team possess the necessary skills to
                                                    complete the task?
                                                </li>
                                                <li>What is the reward for completing the task?</li>
                                                <li>Is the reward of value to you and your team?</li>
                                            </ul>


                                            <p>It’s important you and your team feel you can complete the task,
                                                so set challenging but achievable
                                                goals and make the rewards clear. This could simply be the
                                                satisfaction of completing a project
                                                to a high standard and on time, improved morale in the team or
                                                something more tangible.
                                                Whatever the rewards are, they need to be recognised by those
                                                involved as something worth
                                                having, or they’ll fail to motivate.</p>
                                            <div className="uiheading"><p>Motivating your team through ‘proxy
                                                control’ means getting them ‘on side’ or to act on your behalf.
                                                Be sure to:</p></div>
                                            <ul className="greenbullet-list uiheading">
                                                <li><p>Think about who you’re talking to and pitch what you’re
                                                    saying at the right level
                                                    (don’t overcomplicate things or confuse people by talking
                                                    about things of which
                                                    they have no knowledge)</p></li>
                                                <li>Clearly state your objectives and why they’re important</li>
                                                <li><p>Explain the benefits of the intended outcomes –
                                                    especially if they’re of value
                                                    to your audience</p></li>
                                                <li>Act with integrity – they need to know you’re trustworthy
                                                </li>
                                                <li><p>You need to come across as someone with expertise – show
                                                    you know what
                                                    you’re talking about.</p></li>
                                            </ul>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}